const regex = /\[(.*?)\]/gm;
export const setInputValue = (value: string | undefined) =>
  value ? { value } : null;

export const setCheckboxValue = (value: boolean | undefined) =>
  value ? { value } : null;

export const getInputName = (name: string) => {
  const inputName = name.split(regex).filter((value) => value != '');
  return inputName.pop() || '';
};

export const isTrue = (obj: boolean | string): boolean => {
  return obj === true || obj === 'true';
};

export const toStringValue = (value: string | boolean) => (value ? 'Y' : 'N');
